<template>
  <WdsStack direction-column gap-custom="2rem">
    <WdsAlert v-if="!hasOnboarded" icon info>
      <template #default>{{ $t('Invite pending') }}</template>

      <template #description>
        {{
          $t(
            'Some information is only available after they have accepted your invitation to join Worksome.',
          )
        }}
      </template>
    </WdsAlert>

    <InsuranceInformation
      v-if="hasOnboarded"
      :insurances="workerFragment?.insurances ?? []"
      :currency="workerFragment?.currency"
    />
  </WdsStack>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { WdsAlert, WdsStack } from '@worksome/wds-components'
import { WORKER_VIEW_FRAGMENT } from '@/components/WorkerDetailPanel/graphql/fragments'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { FragmentType, useFragment } from '@/gql'
import InsuranceInformation from '@/components/WorkerDetailPanel/InsuranceInformation.vue'
import { TrustedContactViewFragmentFragment } from '@/gql/graphql'

const props = defineProps<{
  worker?: FragmentType<typeof WORKER_VIEW_FRAGMENT> | null
  trustedContact?: TrustedContactViewFragmentFragment | null
}>()

const workerFragment = computed(() => useFragment(WORKER_VIEW_FRAGMENT, props.worker))

const hasOnboarded = computed(() => props.trustedContact?.status !== 'INVITED')
</script>
